<template>
  <div class="container">
    <van-sticky>
      <PublicHeader :totalName="$t('safe').Withdrawaladdressmanagement" />
      <div class="top">
        <!--  添加新地址-->
        <div class="btn" @click="$router.push({ name: 'AddWalletAddress' })"><van-icon name="plus" color="#fff" size="18" /><span>{{ $t('safe').Addnewaddress }}</span> </div>
      </div>
    </van-sticky>
    <div class="content">
      <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getWalletAddressList" :immediate-check="false">
        <div class="item" v-for="(item, index) in oList" :key="`pro${index}`">
          <div class="left">
            <div class="l1">{{ item.currency }}</div>
            <div class="l2">{{ item.network }}</div>
            <div class="l3">{{ item.address | truncateAddress }}</div>
          </div>
          <van-icon name="delete-o" size="18" color="var(--primary_color)" @click="toDelete(item.walletAddressId)" />
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import PublicHeader from '@/components/publicHeader'

export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
      },
      oList: [],
    }
  },
  mounted() {
    this.getWalletAddressList()
  },
  methods: {
    // 查询用户钱包地址列表
    async getWalletAddressList() {
      if (this.isRun) return
      this.isRun = true
      this.parms.type = this.active
      const res = await userApi.getWalletAddressList(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
    },
    async toDelete(id) {
      // 确认删除地址
      this.$dialog.confirm({
        title: this.$t('safe').Confirmdeleteaddress,
        confirmButtonText: this.$t('public').confirm,
        confirmButtonColor: 'var(--text_color)',
        cancelButtonText: this.$t('public').cancel,
        cancelButtonColor: 'var(--ntext_color)',
      })
        .then(async () => {
          await userApi.delWalletAddress({ walletAddressIds: id })
          this.oList = []
          this.parms.pageNum = 1
          this.finished = false;
          this.getWalletAddressList()
        })
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);

  .top {
    padding: 60px 15px 15px 15px;
    width: 100%;
    background: var(--background_color);

    .btn {
      background: var(--primary_color);
      height: 40px;
      border-radius: 20px;
      border: 0;
      font-size: 15px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        margin-left: 10px;
      }
    }
  }

  .content {
    margin: 15px;

    .item {
      margin-bottom: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        .l1 {
          color: var(--text_color);
          font-size: 16px;
          font-weight: bold;
        }

        .l2 {
          margin-top: 10px;
          color: var(--text_color);
          font-size: 12px;
        }

        .l3 {
          margin-top: 10px;
          color: var(--ntext_color);
          font-size: 13px;
        }
      }
    }
  }
}
</style>
